import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface ComboboxEmptyProps {
  children: ReactNode;
  className?: string;
}

/** Empty-state message shown inside {@link ComboboxContent} when no options match. */
export const ComboboxEmpty: FC<ComboboxEmptyProps> = (props) => {
  return (
    <div
      className={twMerge(
        "px-2 py-1.5 text-muted-foreground select-none",
        props.className,
      )}
    >
      {props.children}
    </div>
  );
};
